import SplashScreen from '../components/SplashScreen';
import TelegramBlockedScreen from '../components/TelegramBlockedScreen';
import AuthRoutes from './AuthRoutes';
import MainRoutes from './MainRoutes';
import useUserData from '../hook/useUserData';
import useCustomCSS from '../hook/useCustomCSS';
import { isTelegram } from '../utils/browser';

const Navigations = () => {
  useCustomCSS();
  const { appReady, user } = useUserData();

  // if (isTelegram) return <TelegramBlockedScreen />;

  if (!appReady) return <SplashScreen />;

  if (!user) return <AuthRoutes />;

  return <MainRoutes />;
};

export default Navigations;
